import axios from "axios";
export const getBitlyShortUrl = axios.create({
  baseURL: "https://api-ssl.bitly.com/v4/shorten",
});

getBitlyShortUrl.interceptors.request.use((config) => {
  config.headers["Content-Type"] = "application/json";
  config.headers["Authorization"] = `Bearer ${import.meta.env.VITE_BITLY_KEY}`;

  return config;
});
